<template>
  <div>
    <label
      for="transition-duration"
      class="block text-sm leading-5 font-medium text-gray-700 mb-1 mt-4"
      >Colors</label
    >
    <section>
      <div class="flex flex-row items-start mt-2 bg-gray-100 p-4 rounded-md">
        <div
          class="flex flex-col items-start mr-12"
          v-if="mode != 'backgroundOnly'"
        >
          <span class="text-gray-600">Text</span>
          <v-swatches
            @input="updateCSS"
            v-model="element.textColor"
            swatches="text-advanced"
          ></v-swatches>
        </div>

        <div
          class="flex flex-col items-start mr-12"
          v-if="mode != 'backgroundOnly'"
        >
          <span class="text-gray-600">Titles</span>
          <v-swatches
            @input="updateCSS"
            v-model="element.titleColor"
            swatches="text-advanced"
            class="p-0 rounded-md"
          ></v-swatches>
        </div>

        <div class="flex flex-col items-start mr-12">
          <span class="text-gray-600">Background</span>
          <v-swatches
            @input="updateCSS"
            v-model="element.backgroundColor"
            swatches="text-advanced"
          ></v-swatches>
        </div>

        <div class="flex flex-col items-start mr-12">
          <span class="text-gray-600">Opacity</span>
          <div class="flex flex-row">
            <circle-slider
              progress-color="#9CA3AF"
              circle-color="#9CA3AF"
              knob-color="#9CA3AF"
              :side="40"
              :max="100"
              :stepSize="1.0"
              v-model="element.backgroundOpacity"
            ></circle-slider>
            <div>
              <h1 class="text-2xl text-gray-500 mt-1 ml-6">
                {{ element.backgroundOpacity }}
              </h1>
            </div>
          </div>
          <!-- <v&#45;swatches -->
          <!--   @input="updateCSS" -->
          <!--   v&#45;model="element.backgroundOpacity" -->
          <!--   swatches="text&#45;advanced" -->
          <!-- ></v&#45;swatches> -->
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// import Component from "../component_location"
import VSwatches from "vue-swatches";
import { debounce } from "@/utils.js";

export default {
  components: { VSwatches },

  props: ["element", "mode"],

  data() {
    return {};
  },
  watch: {
    element: function() {
      // this.updateCSS();
      this.$emit("changed");
    },
  },

  methods: {
    changed() {},
    updateCSS() {
      this.$emit("changed");
    },
  },

  computed: {},

  mounted() {
    this.$emit("changed");
  },
};
</script>

<style></style>
